/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import React from 'react';
import { WithWizard } from 'react-albus';
import { Button } from 'reactstrap';

const BottomNavigation = ({
  className,
  onClickPrev,
  prevLabel,
  onClickNext,
  nextLabel,
  check,
  aiva
}) => {
  return (
    <WithWizard
      render={({ next, previous, step, steps }) => (
        <div className={`wizard-buttons ${className}`}>

          {check !== undefined && check ?
            <Button
              className={`mr-1 invitation-back-button ${steps.indexOf(step) <= 0 ? '' : ''}`}
              onClick={() => {
                onClickPrev(previous, steps, step);
              }}
            >
              {prevLabel}
            </Button> : <Button
                id='backSignup'
              style={{backgroundColor: '#B0B0B0'}}
              className={`mr-1 ${aiva !== undefined ? "invitation-back-button " : ""} ${steps.indexOf(step) <= 0 ? 'disabled' : ''}`}
              onClick={() => {
                onClickPrev(previous, steps, step);
              }}
            >
              {prevLabel}
            </Button>}
          <Button
            color="primary"
            className={
              steps.indexOf(step) >= steps.length - 1 ? 'disabled' : '' + (aiva !== undefined ? ' aiva-background text-white' : '') +
                (check !== undefined && check ? 'invitation-button' : '')
            }
            onClick={() => {
              onClickNext(next, steps, step);
            }}
          >
            {nextLabel}
          </Button>
        </div>
      )}
    />
  );
};
export default BottomNavigation;
